import React from "react";
import { Typography } from "@material-ui/core";
import { CssTextField } from "./style";

export const TournamentForm = ({
	classes,
	tournamentId,
	setTournamentId,
	userCount,
	setUserCount,
}) => {
	return (
		<>
			<Typography variant="h6" className={classes.sectionTitle}>
				Tournament
			</Typography>
			<div className={classes.inputRow}>
				<CssTextField
					className={classes.textField}
					label="Tournament ID"
					variant="outlined"
					value={tournamentId}
					onChange={(e) => setTournamentId(e.target.value)}
					required
				/>
				<CssTextField
					className={classes.textField}
					label="Number of Users"
					variant="outlined"
					type="number"
					value={userCount}
					onChange={(e) => setUserCount(e.target.value)}
					error={
						userCount &&
						(parseInt(userCount) <= 0 || parseInt(userCount) > 10000)
					}
					helperText={
						userCount && parseInt(userCount) <= 0
							? "User count must be positive"
							: userCount && parseInt(userCount) > 10000
							? "User count must be at most 10000"
							: ""
					}
					InputProps={{
						inputProps: { min: 1, max: 10000 },
					}}
					required
				/>
			</div>
		</>
	);
};

export const validateTournamentForm = (formData) => {
	const { tournamentId, userCount } = formData;
	return (
		tournamentId &&
		userCount &&
		parseInt(userCount) > 0 &&
		parseInt(userCount) <= 10000
	);
};
